import { HTMLAttributes, useEffect, useRef, useState } from 'react'
import { Tooltip } from './Tooltip'
import { classNames } from './utils'

interface EllipsisTextProps extends HTMLAttributes<HTMLDivElement> {
  maxWidth?: number
  className?: string
  size?: 'sm' | 'md'
}

export function EllipsisText({
  maxWidth = 200,
  size = 'md',
  className = '',
  children,
  ...props
}: EllipsisTextProps) {
  const divRef = useRef<HTMLDivElement>(null)
  const [showTooltip, setShowTooltip] = useState(false)

  useEffect(() => {
    const el = divRef.current
    if (!el) return
    setShowTooltip(el.scrollWidth > el.offsetWidth)
  }, [children, maxWidth])

  return (
    <Tooltip content={children} disabled={!showTooltip}>
      <div
        ref={divRef}
        style={{ maxWidth: `${maxWidth}px` }}
        className={classNames(
          'overflow-hidden text-ellipsis whitespace-nowrap',
          className,
          {
            'helix-small': size === 'sm',
            'helix-body': size === 'md'
          }
        )}
        {...(showTooltip ? { title: String(children) } : {})}
        {...props}>
        {children}
      </div>
    </Tooltip>
  )
}
